import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  MachinesSerie,
  MachinesSeries,
} from '../../../model/series/machinesSeries';
import {
  APIUrls,
  WebConfigurationService,
} from '../common/web-configuration.service';

@Injectable({
  providedIn: 'root',
})
export class SeriesService extends WebConfigurationService {
  constructor(protected http: HttpClient) {
    super(http);
  }

  /**
   * Get the Series data
   * @returns an Observable
   */
  public getSeriesData(): Observable<MachinesSeries> {
    return this.authGetObs<MachinesSeries>(APIUrls.getMachinesSeriesUrl());
  }

  /**
   * Get the Machines of one Serie
   * @param id the id of the Serie
   * @returns an Observable
   */
  public getMachinesSerieData(id: string): Observable<MachinesSerie> {
    return this.authGetObs<MachinesSerie>(this.getMachinesSerieUrl(id));
  }
}
